import { render } from "./HeaderForm.vue?vue&type=template&id=066fde26&ts=true"
import script from "./HeaderForm.vue?vue&type=script&lang=ts"
export * from "./HeaderForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/HeaderForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "066fde26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('066fde26', __exports__)) {
    api.reload('066fde26', __exports__)
  }
  
  module.hot.accept("./HeaderForm.vue?vue&type=template&id=066fde26&ts=true", () => {
    api.rerender('066fde26', render)
  })

}


export default __exports__